import { render, staticRenderFns } from "./EditBranchComponent.vue?vue&type=template&id=f92faa16&"
import script from "./EditBranchComponent.vue?vue&type=script&lang=js&"
export * from "./EditBranchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports